import axios from 'axios';
import { apiUrl } from '../../utils/constants';

// API call to generate authentication token
export const getToken = async () => {
  const res = await axios.get(`${apiUrl}/chat/meeting`);
  const { token } = res.data;
  return token;
};

// API call to create meeting
export const createMeeting = async ({ token }) => {
  const res = await axios.post(`${apiUrl}/chat/meeting`, {
    token,
  });
  const { meetingId } = res.data;
  return meetingId;
};
